<template>
  <div class="custom-dropdown ms-4" ref="dropdown">
    <button
      class="dropdown-toggle btn btn-sm"
      @click="toggle"
      :class="{ show: isOpen }"
    >
      <span class="dropdown-text">{{ displayTitle }}</span>
    </button>

    <div class="dropdown-menu-2" :class="{ show: isOpen }" v-show="isOpen">
      <div
        class="form-group-row"
        style="position: relative; max-height: 200px; overflow-y: scroll;"
      >
        <div class="user-item ms-4 p-1" v-for="user in users" :key="user._id">
          <input
            class="form-check-input"
            type="radio"
            :id="`user-${user._id}`"
            :name="`user-selection-${_uid}`"
            :value="user._id"
            v-model="selectedUserId"
          />
          <label class="form-check-label" :for="`user-${user.id}`">
            {{ user.full_name }}
          </label>
        </div>
      </div>

      <div
        class="dropdown-footer p-2"
        style="display: flex; flex-direction: row;"
      >
        <button
          @click="cancel"
          class="btn btn-sm btn-outline me-1"
          style="min-width: 100px !important;"
        >
          キャンセル
        </button>
        <button
          @click="apply"
          class="btn btn-sm btn-primary"
          style="min-width: 80px !important;"
        >
          絞り込む
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterDropdown',
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '追加者で絞り込む',
    },
    //   initialSelectedId: {
    //     type: String,
    //     default: null
    //   }
  },
  data() {
    return {
      isOpen: false,
      selectedUserId: null,
    };
  },
  computed: {
    displayTitle() {
      if (this.selectedUserId) {
        const selectedUser = this.users.find(
          (user) => user.id === this.selectedUserId
        );
        return selectedUser ? selectedUser.full_name : this.title;
      }
      return this.title;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$emit('shown');
      } else {
        this.$emit('hidden');
      }
    },
    apply() {
      this.$emit('apply', this.selectedUserId);
      this.isOpen = false;
      this.$emit('hidden');
    },
    cancel() {
      this.selectedUserId = this.initialSelectedId;
      this.isOpen = false;
      this.$emit('hidden');
    },
    handleOutsideClick(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
        this.$emit('hidden');
      }
    },
  },
};
</script>

<style scoped>
.user-item {
  display: flex;
  align-items: center;
}

.user-item .form-check-input {
  /* margin: 0 8px 0 0; */
  flex-shrink: 0;
}

.user-item .form-check-label {
  margin: 0;
  line-height: 1.2;
  cursor: pointer;
  user-select: none;
}

.custom-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  min-width: 200px;
  height: 50px;
  background: #006c6b;
  border: none;
  border-radius: 30px !important;
  /* padding: 6px 12px; */
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
}

.dropdown-toggle:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.dropdown-toggle.show {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.dropdown-menu-2 {
  position: absolute;
  top: 100%;
  left: -50px;
  right: 0;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 2px;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease;
  pointer-events: none;
  width: 315px;
}

.dropdown-menu-2.show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
  color: #000;
}

.form-check-input {
  margin-right: 8px;
}

.form-check-label {
  cursor: pointer;
  user-select: none;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: all 0.15s ease-in-out;
  text-decoration: none;
}

.btn-sm {
  width: 142px;
  height: 50px;
  border-radius: 30px !important;
  font-size: 0.875rem;
  border-radius: 0.2rem;
}

.btn-primary {
  color: #fff;
  background-color: #006c6b;
  border-color: #006c6b;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}

.btn-outline {
  color: #3c3c3c;
  border-color: #3c3c3c;
  background-color: transparent;
}

.btn-outline:hover {
  opacity: 0.8;
}

.me-1 {
  margin-right: 0.25rem;
}

.ms-4 {
  margin-left: 1.5rem;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}
</style>
